// extracted by mini-css-extract-plugin
export default {"container":"SubscriberSec_container__W8TVi","input":"SubscriberSec_input__b8fT4","emailArea":"SubscriberSec_emailArea__irSvU","button":"SubscriberSec_button__Xt7FG"};